import { render } from "./ClientsService.vue?vue&type=template&id=611fcc25&scoped=true"
import script from "./ClientsService.vue?vue&type=script&lang=js"
export * from "./ClientsService.vue?vue&type=script&lang=js"

import "./ClientsService.vue?vue&type=style&index=0&id=611fcc25&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-611fcc25"

export default script